import { SummaryPageContainer } from './components';
import { useTotalTermElementDetailViewSummaryPage } from './hooks';
import { AfterTaxInvestmentsSummarySumTable } from '../../../TtDetails';
import { TotalTermElementDetailViewAfterTaxInvestmentsPageProps } from './types';

export function TotalTermElementDetailViewAfterTaxInvestmentsPage({
  householdID,
  onClickItem,
}: TotalTermElementDetailViewAfterTaxInvestmentsPageProps) {
  const { tPages } = useTotalTermElementDetailViewSummaryPage();

  return (
    <SummaryPageContainer
      heading={tPages('total-term-element-detail-view-after-tax-investments-summary-page-heading')}
      emptyDescription={tPages('total-term-element-detail-view-after-tax-investments-summary-page-empty-description')}
    >
      <AfterTaxInvestmentsSummarySumTable
        hideOnEmpty
        className="mt-10"
        householdID={householdID}
        onClickItem={onClickItem}
      />
    </SummaryPageContainer>
  );
}
